import { render, staticRenderFns } from "./FooterDate.vue?vue&type=template&id=a95cd1bc&"
import script from "./FooterDate.vue?vue&type=script&lang=js&"
export * from "./FooterDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports